module.exports = {};



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/_iterators.js
// module id = bN1p
// module chunks = 0